import { authorizedFetch } from '../../utils/api';

const BASE = '/api/personalize/invest/products';

export const productApi = {
  getResources() {
    return authorizedFetch(`${BASE}/resources`);
  },

  getProducts(params = {}) {
    const query = new URLSearchParams();
    if (params.page) query.set('page', params.page);
    if (params.size) query.set('size', params.size);
    if (params.type?.length) params.type.forEach((t) => query.append('type', t));
    if (params.sort) query.set('sort', params.sort);
    if (params.sortOrder) query.set('sortOrder', params.sortOrder);
    if (params.search) query.set('search', params.search);
    const qs = query.toString();
    return authorizedFetch(`${BASE}${qs ? `?${qs}` : ''}`);
  },

  getProductDetail(productId) {
    return authorizedFetch(`${BASE}/${productId}`);
  },

  getBuyWebview(productId) {
    return authorizedFetch(`${BASE}/${productId}/buy-webview`);
  },
};
